import { useState } from "react"

const AVATAR_COLORS = [
  "bg-emerald-500",
  "bg-blue-500",
  "bg-violet-500",
  "bg-orange-500",
  "bg-pink-500",
  "bg-teal-500",
  "bg-indigo-500",
  "bg-rose-500",
  "bg-amber-500",
  "bg-cyan-500",
]

const hashString = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

const colorForUser = (user) => {
  const seed = String(user?.id ?? user?.name ?? "?")
  return AVATAR_COLORS[hashString(seed) % AVATAR_COLORS.length]
}

const isRenderableAvatarUrl = (avatar) => {
  if (!avatar) return false
  return avatar.startsWith("http://") || avatar.startsWith("https://") || avatar.startsWith("/")
}

const PresenceAvatar = ({ user }) => {
  const [imgFailed, setImgFailed] = useState(false)
  const canShowImg = isRenderableAvatarUrl(user.avatar) && !imgFailed
  const bgColor = colorForUser(user)

  return (
    <div
      className={`w-5 h-5 rounded-full border-2 border-white flex items-center justify-center overflow-hidden ${
        canShowImg ? "bg-slate-200" : bgColor
      }`}
    >
      {canShowImg ? (
        <img
          src={user.avatar}
          alt={user.name}
          className="w-full h-full object-cover"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span className="text-[9px] text-white font-semibold">
          {(user.name || "?").charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  )
}

const PresenceAvatars = ({ users }) => {
  if (!users || users.length === 0) return null
  const visible = users.slice(0, 3)
  return (
    <div
      className="flex items-center -space-x-1.5 flex-shrink-0"
      title={users
        .map((u) => u.name)
        .filter(Boolean)
        .join(", ")}
    >
      {visible.map((u) => (
        <PresenceAvatar key={u.id} user={u} />
      ))}
      {users.length > visible.length && (
        <div className="w-5 h-5 rounded-full bg-slate-400 border-2 border-white flex items-center justify-center">
          <span className="text-[8px] text-white font-semibold">
            +{users.length - visible.length}
          </span>
        </div>
      )}
    </div>
  )
}

export default PresenceAvatars
